import React, { useState } from 'react';
import { Collapse } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import './Faq.css';
 
const { Panel } = Collapse;

function Faq() {
  const [activeKeyColumn1, setActiveKeyColumn1] = useState('1');
  const [activeKeyColumn2, setActiveKeyColumn2] = useState(null);

  const faqColumn1 = [
    {
      key: '1',
      question: 'What is Ndovu Pay?',
      answer: 'NdovuPay is a digital payment platform that enables fast, secure, and streamlined financial transactions for businesses and individuals. It offers a suite of services, including bulk payments, petty cash management, bill payments, supplier settlements, and more.'
    },
    {
      key: '2',
      question: 'How does Ndovu Pay help my business?',
      answer: 'Ndovu Pay streamlines your financial operations by automating payments, reducing manual processes, and providing real-time tracking. This helps you save time, reduce errors, and improve cash flow management for your business.'
    },
    {
      key: '3',
      question: 'Can Ndovu Pay handle bulk payments?',
      answer: 'Yes, Ndovu Pay is designed to handle bulk payments efficiently. You can process multiple payments at once, saving time and reducing the complexity of managing individual transactions.'
    }
  ];

  const faqColumn2 = [
    {
      key: '4',
      question: 'What types of payments can I make with NdovuPay?',
      answer: 'With NdovuPay, you can make various types of payments including bulk payments, petty cash management, bill payments, supplier settlements, salary disbursements, and many other financial transactions.'
    },
    {
      key: '5',
      question: 'Can I download a payment confirmation or receipt for suppliers?',
      answer: 'Yes, you can download payment confirmations and receipts for all your transactions. This feature helps you maintain proper records and provides documentation for your suppliers and accounting purposes.'
    }
  ];


  const handleChangeColumn1 = (key) => {
    setActiveKeyColumn1(key);
  };

  const handleChangeColumn2 = (key) => {
    setActiveKeyColumn2(key);
  };

  const customExpandIcon = ({ isActive }) => {
    return isActive ? (
      <MinusOutlined className="text-[16px] text-[#333]" />
    ) : (
      <PlusOutlined className="text-[16px] text-[#333]" />
    );
  };

  return (
    <>
      <div className='text-[#35332F] font-[400] text-[2.5rem] flex items-center justify-center'>
        Frequently Asked Questions
      </div>
    
      <div className='lg:mt-[3.06rem] mt-[1rem] flex flex-col lg:flex-row justify-between relative'> 
        <div className='flex flex-col gap-6 lg:w-[48%]'>
          <Collapse
            accordion={true}
            activeKey={activeKeyColumn1}
            onChange={handleChangeColumn1}
            expandIcon={customExpandIcon}
            expandIconPosition="start"
            className="faq-collapse"
          >
            {faqColumn1?.map((faq) => (
              <Panel
                header={faq.question}
                key={faq.key}
                className="faq-panel"
              >
                <p className="text-[#7A7493] font-lexendS text-[0.875rem] font-[400] leading-[1.5rem]">{faq?.answer}</p>
              </Panel>
            ))}
          </Collapse>
        </div>

        {/* Column 2 */}
        <div className='flex flex-col gap-6 lg:w-[48%]'>
          <Collapse
            accordion={true}
            activeKey={activeKeyColumn2}
            onChange={handleChangeColumn2}
            expandIcon={customExpandIcon}
            expandIconPosition="start"
            className="faq-collapse"
          >
            {faqColumn2?.map((faq) => (
              <Panel
                header={faq?.question}
                key={faq?.key}
                className="faq-panel"
              >
               <p className="text-[#7A7493] font-lexendS text-[0.875rem] font-[400] leading-[1.5rem]">{faq?.answer}</p>
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    </>
  )
}

export default Faq
